import styled from '@emotion/styled'
import { CvsAutoComplete } from '@components'
import { DeleteButton } from './delete-button'
import {
  IntegrationAssignedFilter,
  IntegrationFilter,
  IntegrationFilterValue,
} from './filter-types'
import { formatSelectedOptions } from '@components/select/cvs-autocomplete'

const FullWidth = styled.div`
  width: 100%;
  display: flex;
`

interface Props {
  filter: IntegrationAssignedFilter
  filterOption: IntegrationFilter
  error?: string | boolean
  isLoading?: boolean
  onFilterChange: (value: IntegrationFilterValue[], filter: IntegrationAssignedFilter) => void
  onFilterDelete: (filter: IntegrationAssignedFilter) => void
}

export const DropdownFilter = ({
  filter,
  filterOption,
  error = false,
  isLoading = false,
  onFilterChange,
  onFilterDelete,
}: Props) => {
  let selectedValue = filter.values.length ? filter.values.map(f => f.value) : undefined

  if (filterOption.multiValue && !selectedValue) {
    selectedValue = []
  }

  const options = filterOption.options
    ? filterOption.options.map(f => ({ label: f.display_name, value: f.value }))
    : []

  function handleFilterChange(value: string | string[]): void {
    const filterValues: IntegrationFilterValue[] = []
    if (value) {
      if (filterOption.multiValue && typeof value === 'object') {
        const values = value
        values.forEach(v => {
          const newValue: IntegrationFilterValue = {
            integration_assignment_filters_id: filter.id,
            value: v,
            display_name: options.find(o => o.value == v)?.label || '',
          }
          filterValues.push(newValue)
        })
      } else if (typeof value === 'string') {
        const newValue: IntegrationFilterValue = {
          integration_assignment_filters_id: filter.id,
          value,
          display_name: options.find(o => o.value == value)?.label || '',
        }
        filterValues.push(newValue)
      }
    }
    onFilterChange(filterValues, filter)
  }

  const hasError = !!error || !selectedValue?.length

  return (
    <FullWidth>
      <CvsAutoComplete
        isClearable
        isMulti={!!filterOption.multiValue}
        margin="dense"
        options={options as never[]}
        label={filterOption.displayName}
        selected={formatSelectedOptions(!!filterOption.multiValue, selectedValue, options)}
        onSelected={handleFilterChange}
        error={error || hasError ? 'Required' : undefined}
        isLoading={isLoading}
      />
      <DeleteButton
        filter={filter}
        onFilterDelete={onFilterDelete}
        marginTop={hasError ? -8 : 9}
        required={filterOption.required}
      />
    </FullWidth>
  )
}
